import { makeMonitorRepository } from "../repositories/repositoryBuilders.js";
import KeyFigureContextRepositoryWrapper from "../repositories/KeyFigureContextRepositoryWrapper.js";
import KeyFigureResult from "../../models/keyFigure/KeyFigureResult.js";
import session from "../session.js";

/**
 * Facilitate fetching key figure values matching some criteria from
 * the server.
 */
export default class KeyFigureResultService {
	constructor({ companyId, keyFigureService }) {
		this._repository = new KeyFigureContextRepositoryWrapper({
			keyFigureService,
			repository: makeMonitorRepository({
				route: "/Accounting2/Company/#companyId/KeyFigureValue",
				defaultFilters: { companyId },
				model: { materializeAll: this._materialize.bind(this) },
				antiForgeryToken: session.getAntiForgeryToken(),
			}),
		});
	}

	/**
	 * Resolve to a `KeyFigureResult` containing matchings values.
	 */
	get({ keyFigureIds, periodType }) {
		const context = { keyFigureIds, periodType };
		const filter = { ...context };

		return this._repository.get({ filter, context });
	}

	/**
	 * Resolve to a `KeyFigureResult` containing matchings values.
	 */
	getValuesForPeriods({ keyFigures, periods, dimensionId }) {
		const context = {
			periodIds: periods.map((period) => period.toString()),
			keyFigureIds: keyFigures.map((keyFigure) => keyFigure.getId()),
			periodType: periods[0].getPeriodType(),
		};

		const filter = { ...context, dimensionId };

		return this._repository.get({ filter, context });
	}

	_materialize(data, context) {
		return KeyFigureResult.materialize(
			{
				values: data,
				periodIds: context.periodIds,
				periodType: context.periodType,
				keyFigureIds: context.keyFigureIds,
			},
			context,
		);
	}
}
